<div class="row shift-top">
    <div class="col-lg-12 col-sm-6 col-12" routerLink="offers/mosque" *ngFor="">
        <!-- Hot deals -->
        <section class="hot-deals bg-main-color p-3 mb-4">
            <h6 class="text-uppercase text-white pb-3 border-bottom">
                hot deal for 

            </h6>
            <div class="hot-deal-list ">
                <div class="hot-deal ">
                    <div class="hot-deal-img">
                        <img src="assets/imgs/icons/bleding.png" alt="" class="img-fluid img-fit">
                    </div>
                    <div class="hot-deal-info">
                        <h6 class="text-uppercase text-white text-truncate">mosque offer</h6>
                        <p class="text-white text-truncate text-uppercase">mobile number or email</p>
                    </div>
                    <div class="hot-deal-offer mb-2">
                        <span class="d-inline-block py-2 px-5 text-uppercase text-white rounded-pill">offer to 20%</span>
                    </div>
                    <div class="hot-deal-rate">
                        <div class="product-rate starrr" ratio="4"></div>
                    </div>
                </div>
            </div>
        </section>
        <!-- ./Hot deals -->

    </div>

</div>